import { render, staticRenderFns } from "./changePwd.vue?vue&type=template&id=46f5f784&"
import script from "./changePwd.vue?vue&type=script&lang=js&"
export * from "./changePwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46f5f784')) {
      api.createRecord('46f5f784', component.options)
    } else {
      api.reload('46f5f784', component.options)
    }
    module.hot.accept("./changePwd.vue?vue&type=template&id=46f5f784&", function () {
      api.rerender('46f5f784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplier/changePwd.vue"
export default component.exports